import flow from 'lodash/fp/flow';
import {
  sanitizeOccupants,
  sanitizeDaysToCheckIn,
  sanitizeStayDates,
  sanitizePayWith,
  sanitizePriceFilters,
  sanitizeClassicRewards,
} from './sanitizers';
import { omitEmpty } from 'lib/object';

const SEARCH_PARAMS = ['checkIn', 'checkOut', 'adults', 'children', 'infants', 'payWith'];

const hasSearchParams = (query) => !!SEARCH_PARAMS.find((k) => k in query);

const sanitize = flow([
  sanitizeOccupants,
  sanitizeDaysToCheckIn,
  sanitizeStayDates,
  sanitizePayWith,
  sanitizePriceFilters,
  sanitizeClassicRewards,
  omitEmpty,
]);

export const sanitizeProperty = (query) => {
  if (hasSearchParams(query)) {
    return sanitize(query);
  } else {
    return query;
  }
};
